import { CroppedImage } from '@weee-fe/module';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import { WeeeIcon } from '@/components/common/Icon';
import { FC } from 'react';
import { ProductTagItemType } from '@/types/product';
import { useRouter } from 'next/router';

const ProductTagItem: FC<{ tag: ProductTagItemType; index: number; className?: string; tagItemClassName?: string }> = ({
  tag,
  index,
  className,
  tagItemClassName = ''
}) => {
  const router = useRouter();

  return (
    <div data-testid={`wid-product-card-tag-${tag?.tag_key}`} className={twMerge(tagItemClassName)}>
      <div
        className={twMerge(
          classNames(
            'flex items-center box-border px-100 h-[18px] rounded-200 enki-body-3xs-strong overflow-hidden max-w-full gap-1 !uppercase',
            {
              'pl-50': !!tag?.tag_icon_url
            },
            {
              'mr-100': !tag?.tail_title
            }
          ),
          className
        )}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          !!tag?.more_link && router.push(tag.more_link);
        }}
        style={{ backgroundColor: tag?.tag_color, color: tag?.tag_font_color }}>
        {!!tag?.tag_icon_url && (
          <CroppedImage
            wrapperClassName="shrink-0 w-4 h-4"
            width={16}
            height={16}
            alt="product-tag"
            aria-hidden="true"
            url={tag?.tag_icon_url}
            showErrorPlaceholder={false}
            showLoadingPlaceholder={false}
            configs={{ renderWidth: 16, renderHeight: 16 }}
          />
        )}
        <span
          style={{ wordBreak: 'break-all', lineHeight: '18px' }}
          className="line-clamp-1"
          dangerouslySetInnerHTML={{ __html: tag?.tag_name }}
        />
        {!!tag?.more_link && (
          <WeeeIcon
            className="shrink-0 w-2.5 scale-75 -ml-0.5"
            type="iconarrow-right"
            style={{ color: tag?.tag_font_color, fontSize: 12 }}
          />
        )}
      </div>
      {!!tag?.tail_title && <div className="text-primary-5 leading-[18px] text-[10px]">{tag?.tail_title}</div>}
    </div>
  );
};

export default ProductTagItem;
